export const SELECT = {
  ALL_OPTION_VALUE: null,
};
